module.exports = __webpack_public_path__ + "img/f_2.e6a0ba40.jpg";